{
  "back_to_home": "Terug naar startscherm",
  "cabins": "Hutten",
  "departure_date": "Vertrekdatum",
  "payment": "Betaling",
  "personal_information": "Persoonlijke gegevens",
  "price_overview": "Prijsoverzicht en extra's",
  "ship": "Schip"
}
